

export const closeEditJobDialogReducer = (state) => {
    state.editJobDialog.isOpen = false;
    state.editJobDialog.job = undefined;
}
